const QuestionType = {
    SHORT: 'short',
    LONG: 'long',
    WYSIWYG: 'wysiwyg',
    NUMBER: 'number',
    EMAIL: 'email',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    MULTI_SELECT: 'multiSelect',
    FILE: 'file'
};

module.exports = {
    QuestionType
};
